import script from "./StaticDateTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaticDateTime.vue?vue&type=script&setup=true&lang=ts"

import "./StaticDateTime.vue?vue&type=style&index=0&id=a8afd91e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8afd91e"]])

export default __exports__